import React from "react";
import img01 from "../../assets/img/images/about-thread.svg";
import img02 from "../../assets/img/images/about_img02.png";
import { Link } from "react-router-dom";

const WhoWeAre = (props) => {
  return (
    <section id="about" className="about-area pt-130 pb-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="about-content wow">
              <div className="section-title mb-30">
                {/* <span className="sub-title">Who we are</span> */}
                <h2 className="title">
                  About Koalia
                </h2>
              </div>
              <p style={{fontSize:'38px'}}>
                  Similar to the Shiba Inu charm on Ethereum, Koalia brings 
                  an adorable twist with her adorable koala charm. Immerse yourself 
                  in the colorful universe of $Koalia, where crypto fuses with humor, and embark on an 		
                  exciting journey to become the next big meme coin sensation on BSC!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
